import { Identifiable } from "./identifiable";
import { id } from "./id";
import { Resource, resource } from "./resource";
import { Task, task } from "./task";

type Allocation = {
  allocatedHours: number;
  spentHours?: number;
  percentComplete: number;
  estimatedAt: number;
  completedAt: string;
  resource: Identifiable<Resource>;
  task?: Identifiable<Task>;
};

const allocation: Allocation = {
  allocatedHours: 0,
  percentComplete: 0,
  estimatedAt: 0,
  completedAt: "",
  resource: { ...resource, uuid: id },
};

export type { Allocation };

export { allocation };
